export enum TransportationTypeEnum {
  VTC = 'vtc',
  TAXI_MOTO = 'taxi-moto',
  TAXI = 'taxi',
  PMR = 'pmr',
}
